import React from 'react';
// eslint-disable-next-line @atlassian/tangerine/import/no-restricted-paths
import ErrorBoundary from '../../ui/error-boundary';
const createSurfaceElement = (type, props, ...children) => /*#__PURE__*/React.createElement(type, props, children);
const incrementBaseHeadingLevel = baseHeadingLevel => {
  const number = Number(baseHeadingLevel.replace('h', ''));
  return `h${Math.min(number + 1, 6)}`;
};
export const createSurfaceRenderer = moduleDictionary => {
  const moduleMap = new Map(Object.entries(moduleDictionary));
  const ZoneRenderer = ({
    zones,
    createMutateAtModule,
    updateId,
    headingLevel,
    createActionBusAtModule,
    context
  }) => /*#__PURE__*/React.createElement(React.Fragment, null, zones && Object.values(zones).flatMap(selectionItems => (selectionItems !== null && selectionItems !== void 0 ? selectionItems : []).map((selectionItem, i) => {
    const module = selectionItem.data;
    if (module === null || !(module !== null && module !== void 0 && module.type) || !(module !== null && module !== void 0 && module.key)) {
      return null;
    }

    // Looks up imported modules, which are (kind of) similar to components and uses that if available
    const componentToRender = moduleMap.get(module.type);
    if (!componentToRender) {
      throw new Error(`Surface Renderer tried to render a component of type ${module === null || module === void 0 ? void 0 : module.type} but no such component exists`);
    }
    const mutate = createMutateAtModule(module.type, module.key);
    return createSurfaceElement(componentToRender, {
      ...(module === null || module === void 0 ? void 0 : module.fields),
      id: module.key,
      key: [module.type, module.key, i].join('-'),
      actionBus: createActionBusAtModule(selectionItem),
      context,
      mutate,
      headingLevel
    }, /*#__PURE__*/React.createElement(ZoneRenderer, {
      key: `${Object.keys(zones !== null && zones !== void 0 ? zones : []).join('-')}-zones `,
      updateId: updateId,
      zones: module === null || module === void 0 ? void 0 : module.zones,
      createMutateAtModule: createMutateAtModule,
      headingLevel: incrementBaseHeadingLevel(headingLevel),
      createActionBusAtModule: createActionBusAtModule,
      context: context
    }));
  })));
  const FallbackHandler = ({
    error,
    isLoading,
    surface,
    fallback,
    children
  }) => {
    if (error) {
      if (!error.name || error.name === '') {
        throw new Error(`Unnamed error in surface renderer. isLoading: ${isLoading}, surfaceExists: ${surface !== undefined}, stack: ${error.stack}`);
      }
      throw error;
    }
    if (isLoading) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, fallback);
    }
    if (!isLoading && !surface) {
      return null;
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null, children);
  };
  const SurfaceRenderer = ({
    surface,
    isLoading,
    fallback,
    error,
    errorFallback = null,
    createMutateAtModule,
    updateId,
    baseHeadingLevel,
    createActionBusAtModule,
    context
  }) => {
    var _surface$zones;
    return /*#__PURE__*/React.createElement(ErrorBoundary, {
      fallback: errorFallback
    }, /*#__PURE__*/React.createElement(FallbackHandler, {
      surface: surface,
      error: error,
      isLoading: isLoading,
      fallback: fallback
    }, /*#__PURE__*/React.createElement(ZoneRenderer, {
      key: `${Object.keys((_surface$zones = surface === null || surface === void 0 ? void 0 : surface.zones) !== null && _surface$zones !== void 0 ? _surface$zones : []).join('-')}-zones `,
      updateId: updateId,
      zones: surface === null || surface === void 0 ? void 0 : surface.zones,
      createMutateAtModule: createMutateAtModule,
      headingLevel: baseHeadingLevel,
      createActionBusAtModule: createActionBusAtModule,
      context: context
    })));
  };
  return SurfaceRenderer;
};